
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.206 11.463c-.307.18-.536.42-.697.735-.166.321-.259.71-.259 1.186V15.5h-1.5v-2.116c0-.677.134-1.308.425-1.872.29-.565.735-1.03 1.284-1.349.576-.33 1.246-.476 1.976-.476h3.13c.687 0 1.38.134 1.98.478.556.323.987.776 1.28 1.347.29.564.425 1.195.425 1.872V15.5h-1.5v-2.116c0-.476-.093-.865-.259-1.186a1.754 1.754 0 00-.697-.734c-.3-.171-.698-.277-1.229-.277h-3.13c-.531 0-.93.106-1.229.277z","fill":"#262626"}}),_c('path',{attrs:{"d":"M6 10.438v1.5H3.901c-.412 0-.709.084-.927.212-.228.138-.399.324-.523.573-.127.257-.201.572-.201.964V15.5H.75v-1.813c0-.585.112-1.135.358-1.63a2.89 2.89 0 011.098-1.195c.5-.296 1.076-.425 1.695-.425H6z","fill":"#262626"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 7.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 1.5a3 3 0 100-6 3 3 0 000 6zM5.625 8a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zm0 1.5a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25z","fill":"#262626"}})])
          )
        }
      }
    